

































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender } from "@/model/Model";
import Urls from "../Urls";
import { LogEvent } from "@/utils";
import { UserInteractionEvent } from "@/model/UserEvents";

@Component
export default class DownloadBanner extends Vue {
  @Prop() public gender!: Gender;
  @Prop() public score!: number;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private get appStoreLink(): string {
    return Urls.AppStore;
  }

  private logAppStore() {
    LogEvent(UserInteractionEvent.DrinkCoach);
  }

  private get playStoreLink(): string {
    return Urls.PlayStore;
  }
}
//
// :width="isMobile ? '100%' : 360"
// :height="isMobile ? 'auto' : 371"
